module.exports = __webpack_public_path__ + "img/ckPayType.179ff636.svg";